export enum Type {
  BLUESKY_USER_DATA_GET_REQUEST = 'app/social/bluesky/USER_DATA_GET_REQUEST',
  BLUESKY_USER_DATA_GET_SUCCESS = 'app/social/bluesky/USER_DATA_GET_SUCCESS',
  BLUESKY_USER_DATA_GET_FAILURE = 'app/social/bluesky/USER_DATA_GET_FAILURE',

  BLUESKY_USER_DATA_GET_AWAIT_REQUEST = 'app/social/bluesky/USER_DATA_GET_AWAIT_REQUEST',
  BLUESKY_USER_DATA_GET_AWAIT_SUCCESS = 'app/social/bluesky/USER_DATA_GET_AWAIT_SUCCESS',
  BLUESKY_USER_DATA_GET_AWAIT_FAILURE = 'app/social/bluesky/USER_DATA_GET_AWAIT_FAILURE',

  BLUESKY_USER_DATA_CLEAR = 'app/social/bluesky/USER_DATA_CLEAR',

  BLUESKY_VIDEO_POST_REQUEST = 'app/social/bluesky/VIDEO_POST_REQUEST',
  BLUESKY_VIDEO_POST_SUCCESS = 'app/social/bluesky/VIDEO_POST_SUCCESS',
  BLUESKY_VIDEO_POST_FAILURE = 'app/social/bluesky/VIDEO_POST_FAILURE',

  BLUESKY_VIDEO_POST_AWAIT_REQUEST = 'app/social/bluesky/VIDEO_POST_AWAIT_REQUEST',
  BLUESKY_VIDEO_POST_AWAIT_SUCCESS = 'app/social/bluesky/VIDEO_POST_AWAIT_SUCCESS',
  BLUESKY_VIDEO_POST_AWAIT_FAILURE = 'app/social/bluesky/VIDEO_POST_AWAIT_FAILURE',

  BLUESKY_AUTHORIZE_SUCCESS = 'app/social/bluesky/AUTHORIZE_SUCCESS',
}
